import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/salary-and-wages-mock/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/salary-and-wages-mock/overview'
    });
  }
});